import { ChatStreamEvent } from "@app/core/chat/domain/model/chat-stream-event";
import { Observable } from "rxjs";

export abstract class ChatRepo {
  /**
   * Streams the answer to a question. The returned Observable emits a `delta`
   * event per incremental chunk and a final `done` event, then completes.
   *
   * Pass the `conversationId` from the previous `done` event to continue that
   * thread, or `null` to start a new one.
   */
  abstract streamQuestion(
    question: string,
    token: string,
    conversationId: string | null
  ): Observable<ChatStreamEvent>;
}
